export const translations_admin = {
  en: {
    // Navigation
    profile: "Profile",
    salaryBenefits: "Salary Benefits",
    attendance: "Attendance",
    leaveManagement: "Leave Management",
    employeeSelfServices: "Self Services",
    calendar: "Calendar",
    settings: "Settings ",
    escalation: "Escalation",
    groups: "Groups",
    messages: "Messages",

    // Employee Data
    unknownEmployee: "Unknown Employee",
    seniorDeveloper: "Senior Developer",
    informationTechnology: "Information Technology",
    activeStatus: "Active",
    emergencyContact: "Emergency Contact Info",

    // Locations
    tahrir: "123 Tahrir Square, Cairo, Egypt",
    cairo: "Cairo",

    // Messages
    logoutError: "Logout error",
    switchError: "Switch error",
    storageError: "Error accessing localStorage for key",

    // Actions
    switchToManager: "Switch to Manager Dashboard",
    logout: "Logout",
    toggleDarkMode: "Switch to Dark Mode",
    toggleLightMode: "Switch to Light Mode",

    // Notifications
    notifications: "Notifications",
  },
  ar: {
    // Navigation
    profile: "الملف الشخصي",
    salaryBenefits: "الراتب",
    attendance: "الحضور",
    leaveManagement: " الإجازات",
    employeeSelfServices: "الخدمات الذاتية ",
    calendar: "التقويم",
    settings: "الإعدادات",
    escalation: "الشكاوى",
    groups: "المجموعات",
    messages: "الرسائل",

    // Employee Data
    unknownEmployee: "موظف غير محدد",
    seniorDeveloper: "مطور أول",
    informationTechnology: "تكنولوجيا المعلومات",
    activeStatus: "نشط",
    emergencyContact: "معلومات جهة الاتصال للطوارئ",

    // Locations
    tahrir: "123 ميدان التحرير، القاهرة، مصر",
    cairo: "القاهرة",

    // Messages
    logoutError: "خطأ في تسجيل الخروج",
    switchError: "خطأ في التبديل",
    storageError: "خطأ في الوصول إلى التخزين المحلي للمفتاح",

    // Actions
    switchToManager: "التبديل إلى لوحة المدير",
    logout: "تسجيل الخروج",
    toggleDarkMode: "التبديل إلى الوضع المظلم",
    toggleLightMode: "التبديل إلى الوضع الفاتح",

    // Notifications
    notifications: "الإشعارات",
  }
};


export const translations_Manager = {
  en: {
    // Main Navigation
    dashboard: "Dashboard",
    employees: "Employees",
    analytics: "Analytics (Locked)",
    attendance: "Attendance",
    reports: "Reports",
    calendar: "Calendar",
    messages: "Messages",
    messagesLocked: "Messages 🔒",
    documentsManagement: "Documents",
    leaveManagement: "Leave",
    solfaManagement: "Solfa",
    employeeChanges: "Employee Changes",
    payroll: "Payroll",
    taxCalculator: "Tax Calculator",
    companyConfiguration: "Company Configuration",
    settingsLocked: "Settings",

    // Location Messages
    locationAccessDenied: "📍 Please allow location access...",
    accessRestricted: "Access Restricted",
    outsideOfficeArea: "You are outside the allowed office area",
    distanceFromOffice: "Distance from office:",
    meters: "meters",
    moveCloserToOffice: "Please move closer to the office to access",

    // System Messages
    featureNotAvailable: "This feature is not available for your organization. Please contact the administrator.",
    underDevelopment: "This page is under development and will be available soon",
    pageWillContain: "This page will contain all the features and tools",
    neededForEffective: "needed for effective",
    management: "management",

    // User Info
    notifications: "Notifications",
    logout: "Logout",
    switchToEmployee: "Switch to Employee Account",
    adminView: "Admin View",
    managerView: "Manager View",
    switchToAdminView: "Switch to Admin View",
    switchToManagerView: "Switch to Manager View",

    // Loading States
    loading: "Loading...",
    error: "An error occurred",
  },
  ar: {
    // التنقل الرئيسي
    dashboard: "لوحة التحكم",
    employees: "الموظفين",
    analytics: "التحليلات (مغلق)",
    attendance: "الحضور والانصراف",
    reports: "التقارير",
    calendar: "التقويم",
    messages: "الرسائل",
    messagesLocked: "الرسائل 🔒",
    documentsManagement: "إدارة المستندات",
    leaveManagement: "إدارة الإجازات",
    solfaManagement: "إدارة السلف",
    employeeChanges: "تغييرات الموظفين",
    payroll: "الرواتب",
    taxCalculator: "حاسبة الضرائب",
    companyConfiguration: "إعدادات الشركة",
    settingsLocked: "الإعدادات ",

    // رسائل الموقع
    locationAccessDenied: "📍 يرجى السماح بالوصول إلى الموقع...",
    accessRestricted: "وصول محظور",
    outsideOfficeArea: "أنت خارج منطقة المكتب المسموح بها",
    distanceFromOffice: "المسافة من المكتب:",
    meters: "متر",
    moveCloserToOffice: "يرجى الاقتراب من مكتب العمل للوصول إلى",

    // رسائل النظام
    featureNotAvailable: "هذه الميزة غير متاحة لمؤسستك. يرجى الاتصال بالمسؤول.",
    underDevelopment: "هذه الصفحة قيد التطوير وستكون متاحة قريبًا",
    pageWillContain: "ستحتوي هذه الصفحة على جميع الميزات والأدوات",
    neededForEffective: "اللازمة لإدارة",
    management: "فعالة",

    // معلومات المستخدم
    notifications: "الإشعارات",
    logout: "تسجيل الخروج",
    switchToEmployee: "التبديل إلى حساب الموظف",
    adminView: "عرض الإداري",
    managerView: "عرض المدير",
    switchToAdminView: "التبديل إلى عرض الإداري",
    switchToManagerView: "التبديل إلى عرض المدير",

    // حالات التحميل
    loading: "جاري التحميل...",
    error: "حدث خطأ",
  }
};

export const translations_Dashboard = {
    en: {
      // Navigation
      dashboard: "Dashboard",
      employees: "Employees",
      payroll: "Payroll",
      analytics: "Analytics(Locked)",
      attendance: "Attendance",
      reports: "Reports",
      calendar: "Calendar",
      messages: "Messages",
      EscalationGroupMapping: "Escalation Mapping",
      documentsManagement: "Documents ",
      leaveManagement: "Leave ",
      solfaManagement: "Solfa ",
      employeeChanges: "Employee Changes",
      taxCalculator: "Tax Calculator",
      adminLevels: "Admin Levels",
      companyConfiguration: "Company Configuration",
      settings: "Settings",

      // Status Messages
      allowLocationAccess: "Please allow location access...",
      accessRestricted: "Access Restricted",
      outsideOfficeArea: "You are currently outside the permitted office area.",
      distanceFromOffice: "Distance from office",
      meters: "meters",
      moveCloserToOffice: "Move closer to the office to unlock",

      // Under Development
      underDevelopment: "This page is under development and will be available soon",
      pageName: "Page",
      effectiveManagement: "This page will contain all features and tools needed for effective",
      management: "management",

      // Loading
      loadingPermissions: "Loading permissions...",
      logout: "Logout",
      switchEmployee: "Employee View",
      accountActions: "Account Actions",
      accountActionsDescription: "Manage your account and session"
    },
    ar: {
      // Navigation
      dashboard: "لوحة التحكم",
      employees: "الموظفين",
      payroll: "الرواتب",
      analytics: "التحليلات (مقفلة)",
      attendance: "الحضور",
      reports: "التقارير",
      calendar: "التقويم",
      messages: "الرسائل",
      EscalationGroupMapping: "ربط الشكاوي",
      documentsManagement: "إدارة المستندات",
      leaveManagement: "إدارة الإجازات",
      solfaManagement: "إدارة السلف",
      employeeChanges: "تغييرات الموظفين",
      taxCalculator: "حاسبة الضرائب",
      adminLevels: "مستويات الإدارة",
      companyConfiguration: "إعدادات الشركة",
      settings: "الإعدادات",

      // Status Messages
      allowLocationAccess: "الرجاء السماح بالوصول للموقع...",
      accessRestricted: "الوصول محظور",
      outsideOfficeArea: "أنت حاليًا خارج منطقة المكتب المسموح بها.",
      distanceFromOffice: "المسافة من المكتب",
      meters: "متر",
      moveCloserToOffice: "اقترب من المكتب لفتح",

      // Under Development
      underDevelopment: "هذه الصفحة قيد التطوير وستكون متاحة قريبًا",
      pageName: "صفحة",
      effectiveManagement: "ستحتوي هذه الصفحة على جميع الميزات والأدوات اللازمة لـ",
      management: "إدارة فعالة",

      // Loading
      loadingPermissions: "جاري تحميل الصلاحيات...",

      logout: "تسجيل الخروج",
      switchEmployee: "عرض الموظف",
      accountActions: "إجراءات الحساب",
      accountActionsDescription: "إدارة حسابك والجلسة"
    }
  };
